
/**
 * Constants.
 */

const isProduction = process.env.NODE_ENV == 'production'
const day = 86400

/**
 * Cookie config.
 */

const cookie = {
  // domain: isProduction ? 'apex.sh' : '127.0.0.1', // only for Apex App?
  // domain: isProduction ? null : '127.0.0.1',
  expires: isProduction ? day * 365 : day * 7,
  secure: isProduction,
  path: '/'
}

/**
 * Stripe config.
 */

const stripe = {
  key: isProduction
    ? 'pk_live_23pGrHcZ2QpfX525XYmiyzmx'
    : 'pk_test_TJlhHtL5MIhZwnBUqo1x2hqN'
}

/**
 * API config.
 */

const api = {
  url: isProduction
    // ? 'https://app.apex.sh/api'
    ? 'https://api.apex.sh'
    : 'http://api.apex.test:5000'
}

/**
 * App config.
 */

const app = {
  url: isProduction
    ? 'https://app.apex.sh'
    : 'http://app.apex.test:3000'
}

/**
 * Configuration.
 */

export default {
  stripe,
  cookie,
  api,
  app
}